import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  handleShowHowToEditReportingDialog,
  selectHasShownExpiredSitesDialog,
  selectIsShowingSomeHowToDialog,
  selectShowExpiredSitesDialog,
} from "../../features/view/viewSlice";

const EDIT_REPORTING_DIALOG_COOKIE_NAME = "hasCheckedHowToEditReportingDialog";
const TIMEOUT = 500;
const MAX_COOKIE_AGE = 60 * 60 * 24 * 400; // 400 days

const useHasShownExpiredSitesDialog = () => {
  const dispatch = useAppDispatch();
  const expiredSitesDialogVisible = useAppSelector(
    selectShowExpiredSitesDialog,
  );
  const hasShownExpiredSitesDialog = useAppSelector(
    selectHasShownExpiredSitesDialog,
  );
  const showingSomeHowToDialog = useAppSelector(selectIsShowingSomeHowToDialog);

  useEffect(() => {
    // getting cookies inside use effect so timer doesn't reset
    const cookies = document.cookie.split(";");
    let hasCheckedEditReportingDialogCookieExists = false;

    for (const cookie of cookies) {
      const [cookieName, cookieVal] = cookie.trim().split("=");
      if (
        cookieName === EDIT_REPORTING_DIALOG_COOKIE_NAME &&
        cookieVal === "true"
      ) {
        hasCheckedEditReportingDialogCookieExists = true;
      }
    }

    if (
      !hasCheckedEditReportingDialogCookieExists &&
      hasShownExpiredSitesDialog &&
      !expiredSitesDialogVisible &&
      !showingSomeHowToDialog
    ) {
      const timeout = setTimeout(() => {
        dispatch(handleShowHowToEditReportingDialog());
        // set cookies
        document.cookie = `${EDIT_REPORTING_DIALOG_COOKIE_NAME}=true; max-age=${MAX_COOKIE_AGE}; path=/; samesite=strict`;
      }, TIMEOUT);

      return () => clearTimeout(timeout);
    }
  }, [
    expiredSitesDialogVisible,
    hasShownExpiredSitesDialog,
    showingSomeHowToDialog,
    dispatch,
  ]);
};

export default useHasShownExpiredSitesDialog;
